import { render, staticRenderFns } from "./workScheduleStatementPercentage.vue?vue&type=template&id=512bb974&"
import script from "./workScheduleStatementPercentage.vue?vue&type=script&lang=js&"
export * from "./workScheduleStatementPercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports